const ACL = {
  SUPER_ADMIN: 'superAdmin',
  CLIENT_USER: 'clientUser',
  HOSPITAL_USER: 'hospitalUser',
  PUBLIC: 'public',
};

export default ACL;
